export enum MonitorCardTypes {
  Live = 'live',
  Expected = 'expected',
  Done = 'done'
}
